module.exports = __webpack_public_path__ + "img/电量统计.8254c154.png";